module.exports = __webpack_public_path__ + "img/客服微信.2a897cd7.png";